// UI texts: story
export default {
  vs: 'VS',
  lootTaken: 'Loot taken',
  lootLost: 'Loot lost',
  hpLeft: 'HP left',
  escaped: 'Escaped',
  contribution: 'Contribution',
  /** 11. 10. 2026 (owner, docs/thepit.md): a win in the Pit over a much higher rating. */
  pitGap: 'Rating gap',
  upset: 'Upset',
  achievement: 'Achievement',
  foundIn: 'Found in {zone}',
  /** 4. 10. 2026 (package 3, 7.g): the chip of a Pristine find's card. */
  pristine: 'Pristine',
  top: 'Top {n}%',
  play: 'Play After Day free',
  download: 'Save image',
  copy: 'Copy link',
  share: 'Share',
  copied: 'Link copied',
  copyFailed: 'Could not copy. Long-press the address bar instead.',
  saved: 'Image saved',
  imageFailed: 'Could not create the image. Try again.',
  shareFailed: 'Sharing did not work. The link is copied instead.',
  post: 'Post',
  story: 'Story',
  format: 'Card format',
  kicker: 'A story from the wasteland',
  pitch: 'Send your survivor out. Close the browser. Come back to a story like this one.',
  notFoundTitle: 'Story not found',
  notFoundBody: 'This story was lost somewhere out there. The link may be wrong or the card was removed.',
  goHome: 'Go to After Day',
} as const;
